import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { WindowRefService } from './core/window-ref.service';
import { SiteInfosService } from '@app/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  stylePage: SafeHtml = '';
  htmlPage: string = '';

  constructor(winRef: WindowRefService, router: Router, route: ActivatedRoute, private siteInfosService: SiteInfosService, protected sanitizer: DomSanitizer, @Inject(DOCUMENT) private _document: Document) { 
    if(winRef.appConfigSite.toManager) {
      let viewresa = /\/viewresa\/*/i, managerResa = /\/manager\/resa\/*/i;
      if(!viewresa.test(window.location.href) && !managerResa.test(window.location.href)) {
        router.navigate(['/manager/list']);
        winRef.appConfigSite.toManager = false;
      }
    }
    if( this.siteInfosService.getEtabData()['chCss'] ) {
      this.stylePage = this.sanitizer.bypassSecurityTrustHtml( this.siteInfosService.getEtabData()['chCss'] );
    }
    if( this.siteInfosService.getEtabData()['chHtml'] ) {
      this.htmlPage = this.siteInfosService.getEtabData()['chHtml'];
    }
  }

  ngOnInit(): void {
    
  }

}
